const isContactLensesOrderLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'CONTACT_LENSES'
;

export { isContactLensesOrderLineItem };
//# sourceMappingURL=line-items.js.map
